import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import Loading from "../components/Loading";
import {useAuth0, withAuthenticationRequired} from "@auth0/auth0-react";
import UserService from "../services/UserService";
import '../styles/components/global-config.css';

export const GlobalConfig = () => {

    // Constants for mapping response data
    const CONFIG_KEYS = {
        RFQ_MAX_RECORDS: 'RFQ_MAX_RECORDS',
        RFQ_PICK_CITY_RADIUS:'RFQ_PICK_CITY_RADIUS',
        RFQ_DROP_CITY_RADIUS: 'RFQ_DROP_CITY_RADIUS',
        LANES100: 'LANES100',
        COLOR100: 'COLOR100',
        LANES90:'LANES90',
        COLOR90: 'COLOR90',
        LANES80: 'LANES80',
        COLOR80: 'COLOR80',
        LANES70: 'LANES70',
        COLOR70: 'COLOR70',
        LANES60: 'LANES60',
        COLOR60: 'COLOR60',
        LANES50: 'LANES50',
        COLOR50: 'COLOR50',
        LANES40:'LANES40',
        COLOR40: 'COLOR40',
        LANES30:'LANES30',
        COLOR30:'COLOR30',
        LANES20:'LANES20',
        COLOR20: 'COLOR20',
        LANES10:'LANES10',
        COLOR10: 'COLOR10',
        NUMBEROFDAYS: 'NUMBEROFDAYS',
        RFQ_MAX_RECORDS_GOLD:'RFQ_MAX_RECORDS_GOLD',
        RFQ_PICK_CITY_RADIUS_GOLD:'RFQ_PICK_CITY_RADIUS_GOLD',
        RFQ_DROP_CITY_RADIUS_GOLD:'RFQ_DROP_CITY_RADIUS_GOLD',
        COPILOT_Q:'COPILOT_Q',
        SILVER_Q:'SILVER_Q',
        GOLD_Q:'GOLD_Q',
        PLATINUM_Q:'PLATINUM_Q',
    };

    // Helper function to find value by key
    const findValueByKey = (data, key) => {
        const item = data.find(item => item.key === key);
        return item ? item.value : null;
    };

    // In your component
    const mapResponseData = (responseData) => {
        return {
            totalRecordsGold: findValueByKey(responseData, CONFIG_KEYS.RFQ_MAX_RECORDS_GOLD),
            startCityRadiusGold: findValueByKey(responseData, CONFIG_KEYS.RFQ_PICK_CITY_RADIUS_GOLD),
            dropCityRadiusGold: findValueByKey(responseData, CONFIG_KEYS.RFQ_DROP_CITY_RADIUS_GOLD),
            numberOfDays: findValueByKey(responseData, CONFIG_KEYS.NUMBEROFDAYS),
            totalRecords: findValueByKey(responseData, CONFIG_KEYS.RFQ_MAX_RECORDS),
            startCityRadius: findValueByKey(responseData, CONFIG_KEYS.RFQ_PICK_CITY_RADIUS),
            dropCityRadius: findValueByKey(responseData, CONFIG_KEYS.RFQ_DROP_CITY_RADIUS),
            lanes10: findValueByKey(responseData, CONFIG_KEYS.LANES10),
            color10: findValueByKey(responseData, CONFIG_KEYS.COLOR10),
            lanes20: findValueByKey(responseData, CONFIG_KEYS.LANES20),
            color20: findValueByKey(responseData, CONFIG_KEYS.COLOR20),
            lanes30: findValueByKey(responseData, CONFIG_KEYS.LANES30),
            color30: findValueByKey(responseData, CONFIG_KEYS.COLOR30),
            lanes40: findValueByKey(responseData, CONFIG_KEYS.LANES40),
            color40: findValueByKey(responseData, CONFIG_KEYS.COLOR40),
            lanes50: findValueByKey(responseData, CONFIG_KEYS.LANES50),
            color50: findValueByKey(responseData, CONFIG_KEYS.COLOR50),
            lanes60: findValueByKey(responseData, CONFIG_KEYS.LANES60),
            color60: findValueByKey(responseData, CONFIG_KEYS.COLOR60),
            lanes70: findValueByKey(responseData, CONFIG_KEYS.LANES70),
            color70: findValueByKey(responseData, CONFIG_KEYS.COLOR70),
            lanes80: findValueByKey(responseData, CONFIG_KEYS.LANES80),
            color80: findValueByKey(responseData, CONFIG_KEYS.COLOR80),
            lanes90: findValueByKey(responseData, CONFIG_KEYS.LANES90),
            color90: findValueByKey(responseData, CONFIG_KEYS.COLOR90),
            lanes100: findValueByKey(responseData, CONFIG_KEYS.LANES100),
            color100: findValueByKey(responseData, CONFIG_KEYS.COLOR100),
            copilotquotas: findValueByKey(responseData, CONFIG_KEYS.COPILOT_Q),
            silverquotas: findValueByKey(responseData, CONFIG_KEYS.SILVER_Q),
            goldquotas: findValueByKey(responseData, CONFIG_KEYS.GOLD_Q),
            platinumquotas: findValueByKey(responseData, CONFIG_KEYS.PLATINUM_Q)
        };
    };

    const registerOptions = {
        copilotquotas: {
            required: "copilotquotas is required",
            maxLength: {
                value: 108,
                message: "copilotquotas cannot be more than 108 characters"
            }
        },
        silverquotas: {
            required: "silverquotas is required",
            maxLength: {
                value: 108,
                message: "silverquotas cannot be more than 108 characters"
            }
        },
        goldquotas: {
            required: "goldquotas is required",
            maxLength: {
                value: 108,
                message: "goldquotas cannot be more than 108 characters"
            }
        },
        platinumquotas: {
            required: "platinumquotas is required",
            maxLength: {
                value: 108,
                message: "platinumquotas cannot be more than 108 characters"
            }
        },
        totalRecords: {
            required: "totalRecords is required",
            maxLength: {
                value: 108,
                message: "totalRecords cannot be more than 108 characters"
            }
        },
        startCityRadius: {
            required: "startCityRadius is required",
            maxLength: {
                value: 30,
                message: "startCityRadius cannot be more than 30 characters"
            }
        },
        dropCityRadius: {
            required: "dropCityRadius is required",
            maxLength: {
                value: 50,
                message: "dropCityRadius cannot be more than 50 characters"
            }
        },
        totalRecordsGold: {
            required: "totalRecordsGold is required",
            maxLength: {
                value: 108,
                message: "totalRecordsGold cannot be more than 108 characters"
            }
        },
        startCityRadiusGold: {
            required: "startCityRadiusGold is required",
            maxLength: {
                value: 30,
                message: "startCityRadiusGold cannot be more than 30 characters"
            }
        },
        dropCityRadiusGold: {
            required: "dropCityRadiusGold is required",
            maxLength: {
                value: 50,
                message: "dropCityRadiusGold cannot be more than 50 characters"
            }
        },
        numberOfDays: {
            required: "Number of Days is required",
            maxLength: {
                value: 3,
                message: "Number of Days than 3 characters"
            }
        },
        lanes100: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color100: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes90: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color90: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes80: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color80: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes70: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color70: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes60: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color60: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes50: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color50: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes40: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color40: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes30: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color30: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes20: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color20: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        },
        lanes10: {
            required: "Lanes is required",
            maxLength: {
                value: 30,
                message: "Zip cannot be more than 30 characters"
            }
        },
        color10: {
            required: "Color is required",
            maxLength: {
                value: 100,
                message: "State cannot be more than 50 characters"
            }
        }
    };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset } = useForm();

    // user state for form
    const [farelanesUser, setFarelanesUser] = useState(null);
    const [originalResponse, setOriginalResponse] = useState(null);

    const [state, setState] = useState({
        showResult: false,
        loading: false,
        apiMessage: 'Tickers are loading ....',
        error: null,
    });

    const {
        getAccessTokenSilently,
        user
    } = useAuth0();

    const callApi = async () => {
        try {
            const token = await getAccessTokenSilently();
            // Usage in your API call
            UserService.config(token, user).then(
                response => {
                    const mappedData = mapResponseData(response.data);
                    setFarelanesUser(mappedData);
                    setOriginalResponse(response.data);
                    setState({
                        ...state,
                        showResult: true,
                        apiMessage: response.data
                    });
                }
            );

        } catch (error) {
            setState({
                ...state,
                error: error.error,
            });
        }
    };

    // effect runs on component mount
    useEffect(() => {
        // simulate async api call with set timeout
        callApi().then();
    }, []);

    // effect runs when user state is updated
    useEffect(() => {
        // reset form with user data
        reset(farelanesUser);
    }, [farelanesUser]);

    const findIndexByKey = (array, key) => {
        return array.findIndex(item => item.key === key);
    };

    async function onSubmit(data) {
        // display form data on submit
        const token = await getAccessTokenSilently();
        setState({
            message: "",
            loading: true
        });

        console.log("****");
        console.log(farelanesUser);
        let payload = farelanesUser.response;
        let originalPayload = originalResponse;
        console.log("**6**");
        console.log(originalPayload)

        console.log("**7**");

        console.log("**8**");

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.RFQ_MAX_RECORDS)].value = data.totalRecords
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.RFQ_PICK_CITY_RADIUS)].value  = data.startCityRadius
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.RFQ_DROP_CITY_RADIUS)].value =  data.dropCityRadius

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES100)].value =  data.lanes100
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR100)].value = data.color100

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES90)].value = data.lanes90
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR90)].value  = data.color90

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES80)].value  = data.lanes80
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR80)].value   = data.color80

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES70)].value = data.lanes70
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR70)].value  = data.color70

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES60)].value =  data.lanes60
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR60)].value =  data.color60

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES50)].value =  data.lanes50
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR50)].value =  data.color50

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES40)].value =  data.lanes40
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR40)].value =  data.color40

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES30)].value = data.lanes30
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR30)].value =  data.color30

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES20)].value = data.lanes20
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR20)].value =  data.color20

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.LANES10)].value =  data.lanes10
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COLOR10)].value = data.color10
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.NUMBEROFDAYS)].value =  data.numberOfDays

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.RFQ_DROP_CITY_RADIUS_GOLD)].value = data.dropCityRadiusGold
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.RFQ_PICK_CITY_RADIUS_GOLD)].value = data.startCityRadiusGold
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.RFQ_MAX_RECORDS_GOLD)].value = data.totalRecordsGold

        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.COPILOT_Q)].value = data.copilotquotas
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.SILVER_Q)].value =data.silverquotas
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.GOLD_Q)].value = data.goldquotas
        originalPayload[findIndexByKey(originalPayload, CONFIG_KEYS.PLATINUM_Q)].value = data.platinumquotas

        console.log("updating payload ====>>>>");

        console.log(originalPayload);
        UserService.updateConfig(originalPayload, token).then(
            response => {
                setState({
                    content: response.data,
                    loading: false,
                    message: 'Success!'
                });
            },
            error => {
                if (error.response && error.response.status === 401) {
                }
            }
        );

        return false;
    }

    return (
        <div className="global-config-container">
            <div className="bg-image">
                {!farelanesUser && (
                    <div className="text-center p-3">
                        <Loading />
                    </div>
                )}

                {farelanesUser && (
                    <div className="container-fluid">
                        <div style={{ marginTop: "20px", marginBottom: "15px" }}>
                            <p className="dashboard-text container-fluid">
                                Configure global system settings including subscription quotas, RFQ parameters, and lane confidence thresholds. This configuration affects all users and system behavior across the platform.
                            </p>
                        </div>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            {/* Subscription Quotas */}
                            <div className="card mb-4">
                                <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                    <h5 className="mb-0" style={{ color: '#495057' }}>Subscription Quotas</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label><b>CoPilot</b></label>
                                                <input 
                                                    name="copilotquotas"
                                                    type="text" 
                                                    {...register('copilotquotas', registerOptions.copilotquotas)}
                                                    className="form-control"
                                                    placeholder="Enter quota"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label><b>Silver</b></label>
                                                <input 
                                                    name="silverquotas"
                                                    type="text" 
                                                    {...register('silverquotas', registerOptions.silverquotas)}
                                                    className="form-control"
                                                    placeholder="Enter quota"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label><b>Gold</b></label>
                                                <input 
                                                    name="goldquotas"
                                                    type="text" 
                                                    {...register('goldquotas', registerOptions.goldquotas)}
                                                    className="form-control"
                                                    placeholder="Enter quota"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label><b>Platinum</b></label>
                                                <input 
                                                    name="platinumquotas"
                                                    type="text" 
                                                    {...register('platinumquotas', registerOptions.platinumquotas)}
                                                    className="form-control"
                                                    placeholder="Enter quota"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Platinum Settings */}
                            <div className="card mb-4">
                                <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                    <h5 className="mb-0" style={{ color: '#495057' }}>Platinum Settings</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label><b>RFQ Number of Records</b></label>
                                                <input 
                                                    name="totalRecords"
                                                    type="text" 
                                                    {...register('totalRecords', registerOptions.totalRecords)}
                                                    className="form-control"
                                                    placeholder="Enter number of records"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label><b>Start City Radius (mi)</b></label>
                                                <input 
                                                    name="startCityRadius"
                                                    type="text" 
                                                    {...register('startCityRadius', registerOptions.startCityRadius)}
                                                    className="form-control"
                                                    placeholder="Enter radius in miles"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label><b>End City Radius (mi)</b></label>
                                                <input 
                                                    name="dropCityRadius"
                                                    type="text" 
                                                    {...register('dropCityRadius', registerOptions.dropCityRadius)}
                                                    className="form-control"
                                                    placeholder="Enter radius in miles"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Gold Settings */}
                            <div className="card mb-4">
                                <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                    <h5 className="mb-0" style={{ color: '#495057' }}>Gold Settings</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label><b>RFQ Number of Records</b></label>
                                                <input 
                                                    name="totalRecordsGold"
                                                    type="text" 
                                                    {...register('totalRecordsGold', registerOptions.totalRecordsGold)}
                                                    className="form-control"
                                                    placeholder="Enter number of records"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label><b>Start City Radius (mi)</b></label>
                                                <input 
                                                    name="startCityRadiusGold"
                                                    type="text" 
                                                    {...register('startCityRadiusGold', registerOptions.startCityRadiusGold)}
                                                    className="form-control"
                                                    placeholder="Enter radius in miles"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label><b>End City Radius (mi)</b></label>
                                                <input 
                                                    name="dropCityRadiusGold"
                                                    type="text" 
                                                    {...register('dropCityRadiusGold', registerOptions.dropCityRadiusGold)}
                                                    className="form-control"
                                                    placeholder="Enter radius in miles"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Confidence Index */}
                            <div className="card mb-4">
                                <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                    <h5 className="mb-0" style={{ color: '#495057' }}>Confidence Index</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label><b>Number of Days (15, 30, 60, 120)</b></label>
                                                <input 
                                                    name="numberOfDays"
                                                    type="text" 
                                                    {...register('numberOfDays', registerOptions.numberOfDays)}
                                                    className="form-control"
                                                    placeholder="Default: 120"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Lane Confidence Settings */}
                            <div className="card mb-4">
                                <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                    <h5 className="mb-0" style={{ color: '#495057' }}>Lane Confidence Settings</h5>
                                </div>
                                <div className="card-body">
                                    {[
                                        { percent: '100%', lanes: 'lanes100', color: 'color100' },
                                        { percent: '90%', lanes: 'lanes90', color: 'color90' },
                                        { percent: '80%', lanes: 'lanes80', color: 'color80' },
                                        { percent: '70%', lanes: 'lanes70', color: 'color70' },
                                        { percent: '60%', lanes: 'lanes60', color: 'color60' },
                                        { percent: '50%', lanes: 'lanes50', color: 'color50' },
                                        { percent: '40%', lanes: 'lanes40', color: 'color40' },
                                        { percent: '30%', lanes: 'lanes30', color: 'color30' },
                                        { percent: '20%', lanes: 'lanes20', color: 'color20' },
                                        { percent: '10%', lanes: 'lanes10', color: 'color10' }
                                    ].map((item, index) => (
                                        <div key={index} className="row mb-3">
                                            <div className="col-md-1">
                                                <input 
                                                    type="text" 
                                                    value={item.percent} 
                                                    disabled={true}
                                                    className="form-control text-center"
                                                    style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                />
                                            </div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label><b>Internal # Lanes</b></label>
                                                    <input 
                                                        type="text" 
                                                        {...register(item.lanes, registerOptions[item.lanes])}
                                                        className="form-control"
                                                        placeholder="Enter lanes"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="form-group">
                                                    <label><b>Color Code</b></label>
                                                    <input 
                                                        type="text" 
                                                        {...register(item.color, registerOptions[item.color])}
                                                        className="form-control"
                                                        placeholder="Enter color"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="text-center mb-4">
                                <button 
                                    type="submit" 
                                    className="btn btn-lg"
                                    style={{
                                        backgroundColor: '#ff8c00',
                                        color: 'black',
                                        fontWeight: '700',
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        border: 'none',
                                        padding: '12px 30px',
                                        fontSize: '16px'
                                    }}
                                >
                                    {state.loading && (
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                    )}
                                    Save Configuration
                                </button>
                            </div>

                            {/* Success Message */}
                            {state.content && (
                                <div className="alert alert-success text-center">
                                    <h5 className="mb-0">Configuration Saved Successfully!</h5>
                                </div>
                            )}
                        </form>
                    </div>
                )}
            </div>
        </div>
    );
};

export default withAuthenticationRequired(GlobalConfig, {
    onRedirecting: () => <Loading/>,
});
